import { CanPurchaseDomainErrors } from '../../typing';
import { parseDomain } from '../../utils';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const canPurchaseDomain = async _ref => {
  let {
    httpClient,
    request: {
      domain
    }
  } = _ref;
  if (!domain) {
    return {
      canPurchase: false
    };
  }
  const parsedDomain = domain.main ? domain : parseDomain(domain);
  const {
    domainTlds
  } = await dynamicLoadApiQueries(httpClient);
  const [{
    availability
  }, {
    tlds: wixSupportedTlds
  }] = await Promise.all([checkAvailability({
    httpClient,
    request: {
      domain: parsedDomain.asciiDomain
    }
  }), domainTlds({})]);
  const isAvailable = !!(availability != null && availability.available);
  const isWixSupportedTld = wixSupportedTlds.find(_ref2 => {
    let {
      tld
    } = _ref2;
    return tld === parsedDomain.tld;
  });
  if (!isWixSupportedTld) {
    return {
      error: CanPurchaseDomainErrors.NOT_SUPPORTED_TLD,
      canPurchase: isAvailable,
      premium: availability == null ? void 0 : availability.premium
    };
  }
  if (!isAvailable) {
    return {
      error: CanPurchaseDomainErrors.NOT_AVAILABLE,
      canPurchase: false,
      premium: availability == null ? void 0 : availability.premium
    };
  }
  return {
    canPurchase: true,
    premium: availability == null ? void 0 : availability.premium
  };
};
export const checkAvailability = async _ref3 => {
  let {
    httpClient,
    request: {
      domain
    }
  } = _ref3;
  const {
    checkDomainAvailability
  } = await dynamicLoadApiQueries(httpClient);
  try {
    const {
      availability
    } = await checkDomainAvailability({
      domain
    });
    return {
      availability
    };
  } catch (e) {
    var _e$response;
    // Don't delete this part
    const statusCode = (e == null || (_e$response = e.response) == null ? void 0 : _e$response.status) ?? (e == null ? void 0 : e.status);
    if (statusCode !== 400) {
      throw e;
    }
    return {
      availability: {
        available: false
      }
    };
  }
};
//# sourceMappingURL=canPurchaseDomain.js.map